/*
 *
 * ComparativeAnalysis reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_HEADERS_SUCCESS,
  GET_FILTERS_SUCCESS,
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_DIVISIONS_CHILDS_WATCHER,
  GET_INDICATOR_WATCHER,
  GET_INDICATOR_SUCCESS,
  GET_INDICATOR_FAILED,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_SUCCESS,
  GET_MEASURE_WATCHER,
  GET_MEASURE_INFO_SEGMENT_WATCHER,
  GET_MEASURE_INFO_SEGMENT_FAILED,
  GET_MEASURE_INFO_SEGMENT_SUCCESS,
  GET_DIVISIONS_ROWS_WATCHER,
  GET_DIVISIONS_ROWS_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  isLoadingHeaders: false,
  headers: [],
  divisions: [],
  measure_general: [],
  filters_divisions: [],
  employees: 0,
  indicatorLoading: false,
  indicator: {},
  filters_segments: [],
  measureColorRange: null,
  measureInfo: {
    segment_name: "",
  },
  isLoadinExtraRows: false,
  lastPage: 0
})

function comparativeAnalysisReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MEASURE_INFO_SEGMENT_FAILED:
      return state.set("measureInfo", null)
    case GET_MEASURE_INFO_SEGMENT_WATCHER:
      return state.set("isLoadingHeaders", true).set("measureInfo", {})
    case GET_MEASURE_INFO_SEGMENT_SUCCESS:
      return state
        .set("isLoadingHeaders", false)
        .set("measureInfo", action.payload)
        .set("filters_segments", action.payload.segments)
    case GET_HEADERS_SUCCESS:
      return state.set("isLoadingHeaders", false).set("headers", action.payload)
    case GET_FILTERS_SUCCESS:
      return state
        .set("filters_divisions", action.payload.divisions)
        .set("divisionsTotal", action.payload.divisionsTotal)
    case GET_DIVISIONS_WATCHER:
      return state
        .set("isLoading", true)
        .set("divisions", [])
        .set("headers", action.payload.first ? [] : state.get("headers"))
        .set('lastPage', 1)
    case GET_DIVISIONS_SUCCESS:
  
      return state
        .set("isLoading", false)
        .set("divisions", action.payload.divisions)
        .set(
          "employees",
          Number.isInteger(action.payload.employees)
            ? action.payload.employees
            : state.get("employees")
        )
        .set('lastPage', action.payload.lastPage)
        // .set('isLoadingExtraRows', false)
    case GET_DIVISIONS_CHILDS_WATCHER:
      return state.set("isLoading", true)

    case GET_DIVISIONS_ROWS_WATCHER:
      return state.set("isLoadingExtraRows", true)

    case GET_DIVISIONS_ROWS_SUCCESS:
      const divisions = state.get("divisions").concat(action.payload.divisions)
      return state
        .set("isLoadingExtraRows", false)
        .set("divisions", divisions)
        // .set(
        //   "employees",
        //   Number.isInteger(action.payload.employees)
        //     ? action.payload.employees
        //     : state.get("employees")
        // )
        .set('lastPage', action.payload.lastPage)
    case GET_INDICATOR_WATCHER:
      return state.set("indicatorLoading", true)
    case GET_INDICATOR_SUCCESS:
      return state
        .set("indicatorLoading", false)
        .set("indicator", action.payload)
    case GET_INDICATOR_FAILED:
      return state.set("indicatorLoading", true)

    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set("measureColorRange", action.payload.report_color_range)
    case GET_MEASURE_SUCCESS:
      return state.set("measure_general", action.payload.measure)
    default:
      return state
  }
}

export default comparativeAnalysisReducer
